import styled from 'styled-components';
import { LayoutType } from '../../types';
import { devices, height } from '../../styles/viewports.styles';
import { KOALA } from 'HubStyleTokens/colors';
export const FlowStepComponent = styled.div.withConfig({
  displayName: "ViewContainerstyles__FlowStepComponent",
  componentId: "sc-1mlp2ym-0"
})(["display:grid;align-content:center;flex:1;@media ", "{justify-content:center;align-content:center;}", ""], devices.desktop, props => props.layoutType === LayoutType.CentredStep && props.alignCentredStepAtTheTop && `
    align-content: start;
    justify-content: center;

    @media ${height.small} {
      padding-top: 40px;
      align-content: start;
    }

    @media ${height.medium} {
      padding-top: 100px;
      align-content: start;
    }

    @media ${height.large} {
      padding-top: 10vh;
      align-content: start;
    }`);
export const ViewComponent = styled.div.withConfig({
  displayName: "ViewContainerstyles__ViewComponent",
  componentId: "sc-1mlp2ym-1"
})(["display:grid;grid-template-rows:minmax(65vh,max-content) auto;grid-area:main;", " @media ", "{width:100%;justify-self:center;grid-template-columns:50% 50%;grid-template-rows:auto;", "}@media ", "{max-width:calc(100% - 1 * (100% - 1201px));}"], props => (props.layoutType === LayoutType.CentredStep || props.layoutType === LayoutType.FramedCentredStep) && `grid-template-rows: 100%;`, devices.desktop, props => (props.layoutType === LayoutType.CentredStep || props.layoutType === LayoutType.FramedCentredStep) && `grid-template-columns: 100%;`, devices.large);
export const ContentHolder = styled.div.withConfig({
  displayName: "ViewContainerstyles__ContentHolder",
  componentId: "sc-1mlp2ym-2"
})(["width:100%;@media ", ",@media ", ",{", "}@media ", "{width:450px;overflow:visible;", ";", "}@media ", "{", "}"], devices.tablet, devices.desktop, props => props.layoutType === LayoutType.FramedCentredStep && `
      min-height: 700px;
      height: 100%;
      border-radius: 8px;
      border: 1px solid ${KOALA};
      box-shadow: 0px 4px 20px rgba(81, 111, 144, 0.2);
      padding-top: 40px;
      padding-bottom: 30px;
      padding-left: 48px;
      padding-right: 48px;
      `, devices.desktop, props => props.layoutType === LayoutType.FramedCentredStep && ` width: 528px;`, props => props.layoutType === LayoutType.CentredStep && ` width: 50rem;`, devices.large, props => props.layoutType === LayoutType.CentredStep && props.alignCentredStepAtTheTop && ` width: 70rem;`);
export const FlowStep = styled.div.withConfig({
  displayName: "ViewContainerstyles__FlowStep",
  componentId: "sc-1mlp2ym-3"
})(["display:flex;flex-direction:column;"]);